import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import Form from '../../../components/form/Form';
import { formatCurrency, formInput } from '../../../components/helpers';
import { Input, Message } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';
import { PartialPayment } from './event-modals/partialPayment';
import {
  ReservationExtraInfo,
  verifyReservationForm,
  reservationRequiresCivil,
} from './components/reservationExtraInfo';
import { TarjetahabienteInfo } from './components/tarjetahabienteInfo';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';
import Swal from 'sweetalert2';
import { shouldLockGuestIdentity } from 'src/components/helpers/guests/guestIdentity';

const StepFillDataContainer = styled.div`
  .Registration__form {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    h2 {
      font-size: 2rem;
      color: #2c3e50;
      margin-bottom: 2rem;
      text-align: center;
      font-weight: 600;
    }

    p {
      color: #7f8c8d;
      line-height: 1.6;
      margin-bottom: 1rem;
      text-align: center;

      strong {
        color: #2c3e50;
        font-weight: 600;
      }
    }

    .line-break {
      background: #f8f9fa;
      padding: 1.5rem;
      border-radius: 8px;
      margin: 1rem 0;
      color: #2c3e50;
      line-height: 1.6;

      p {
        text-align: left;
        margin-bottom: 1rem;
      }
    }

    h4 {
      color: #e74c3c;
      text-align: center;
      margin: 1rem 0;
      font-weight: 500;
    }

    .ui.form {
      .field {
        margin-bottom: 1.5rem;

        label {
          color: #2c3e50;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        input,
        select {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 1rem;
          transition: all 0.3s ease;

          &:focus {
            border-color: #3498db;
            box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
          }

          &.error {
            border-color: #e74c3c;
            background-color: #fdf0ed;
          }
        }

        .ui.selection.dropdown {
          min-height: 45px;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 1rem;
          transition: all 0.3s ease;

          &:hover {
            border-color: #3498db;
          }

          &.error {
            border-color: #e74c3c;
            background-color: #fdf0ed;
          }
        }
      }
    }

    .donation-info {
      background: #f8f9fa;
      padding: 1.5rem;
      border-radius: 8px;
      margin: 1.5rem 0;
      border: 1px solid #e9ecef;

      p {
        text-align: left;
        margin-bottom: 1rem;
        color: #2c3e50;

        strong {
          color: #e74c3c;
        }
      }
    }

    .donation-amount {
      font-size: 1.25rem;
      color: #2c3e50;
      text-align: center;
      margin: 1.5rem 0;
      padding: 1rem;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;

      strong {
        color: #3498db;
      }
    }

    .ui.button {
      width: 100%;
      background: #3498db;
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-weight: 500;
      transition: all 0.2s ease;
      margin-top: 1.5rem;

      &:hover {
        background: #2980b9;
        transform: translateY(-1px);
      }

      &:disabled {
        background: #bdc3c7;
        cursor: not-allowed;
      }
    }

    a {
      color: #3498db;
      text-decoration: none;
      transition: all 0.2s ease;

      &:hover {
        color: #2980b9;
        text-decoration: underline;
      }
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .Registration__form {
      padding: 1rem;

      h2 {
        font-size: 1.5rem;
      }
    }
  }
`;

const ReservationStepFillData = (props) => {
  const {
    inputs,
    setInputs,
    setStep,
    defaulteventSlugname,
    firstEventOfQuery,
    sendReservation,
    loading,
    services,
    onGuestUpdated,
  } = props;
  const [errorInputs, set_errorInputs] = React.useState({});

  const getTotalDonation = () => {
    let eventCost = parseInt(firstEventOfQuery.paidEvent, 10);
    const specialPricing = firstEventOfQuery.specialPricing;
    if (specialPricing) {
      const isGroupLeader = Array.isArray(inputs.groupLeader) && inputs.groupLeader.length > 0;
      const isVolunteer = inputs?.serviceArea;
      if (
        typeof specialPricing.isLeader === 'number' &&
        isGroupLeader &&
        eventCost > Math.abs(specialPricing.isLeader)
      ) {
        eventCost = Math.abs(specialPricing.isLeader);
      }
      if (
        typeof specialPricing.isVolunteer === 'number' &&
        isVolunteer &&
        eventCost > Math.abs(specialPricing.isVolunteer)
      ) {
        eventCost = Math.abs(specialPricing.isVolunteer);
      }
    }
    return eventCost;
  };

  const totalDonation = getTotalDonation();

  const nextStep = (e) => {
    e.preventDefault();
    if (verifyReservationForm(firstEventOfQuery, defaulteventSlugname, inputs, set_errorInputs)) {
      window.scrollTo(0, 0);
      return;
    }
    const { eventSlugname } = firstEventOfQuery;
    const { email, name, lastName, identification, volunteerDonationAmount } = inputs;
    if (totalDonation || volunteerDonationAmount > 0) {
      if (!email) {
        Swal.fire('Por favor, ingresa tu correo electrónico.');
        return;
      }
      const extra3 =
        inputs.es_tarjetahabiente === 'No' &&
        inputs.nombre_tarjetahabiente &&
        inputs.identificacion_tarjetahabiente
          ? `&extra3=${encodeURIComponent(
              `${inputs.nombre_tarjetahabiente}_${inputs.identificacion_tarjetahabiente}`
            )}`
          : '';
      sendReservation({
        goToSummary: false,
        redirect: `/payucheckout?amount=${parseInt(
          totalDonation / (inputs.partialPaid ? 2 : 1) +
            (Math.abs(parseInt(inputs.volunteerDonationAmount)) || 0)
        )}&description=${eventSlugname}&buyerEmail=${email}&buyerFullName=${name} ${lastName}&identification=${identification}&extra1=${name} ${lastName}${extra3}`,
      });
      return;
    }
    if (
      Object.values(services || {})?.flat?.(2)?.length === 1 ||
      Object.values(services || {})?.[0]?.[0]?.oneForManyEvents
    ) {
      const nextInputs = {
        ...inputs,
        service: firstEventOfQuery,
        date: firstEventOfQuery.date,
      };
      setInputs(nextInputs);
      if (nextInputs.service && !nextInputs.reserved) {
        sendReservation({ inputsOverride: nextInputs });
      }
      return;
    }
    setStep('selectAService');
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const handleDropDown = ({ name, value }) => {
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const selectHandle = (a, { value, name }) => handleInputs({ target: { value, name } });

  const moreInfo = () => {
    return (
      <>
        <ReservationExtraInfo
          inputs={inputs}
          handleInputs={handleInputs}
          selectHandle={selectHandle}
          errorInputs={errorInputs}
          defaulteventSlugname={defaulteventSlugname}
          event={firstEventOfQuery}
        />

        {totalDonation > 0 && (
          <div className="donation-info">
            <p>
              <strong>Importante:</strong> Si no se concreta la donación al momento de entrar a la
              pagina de pagos, deberás hacer otra inscripción y comenzar otra donación; de lo
              contrario no podremos garantizar tu cupo.
            </p>
            <p>
              <strong>
                Recuerda que tu cupo solo queda reservado únicamente al momento de completar el pago
                de la donación.
              </strong>
            </p>
          </div>
        )}
        {firstEventOfQuery['volunteerDonation'] && (
          <div>
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Donación voluntaria',
              name: 'volunteerDonationAmount',
              value: inputs['volunteerDonationAmount'],
              errorInputs,
              type: 'number',
            })}
          </div>
        )}
        <PartialPayment
          event={firstEventOfQuery}
          inputs={inputs}
          setInputs={setInputs}
          totalDonation={totalDonation}
        />
        {totalDonation > 0 && (
          <div className="donation-amount">
            <strong>{inputs.partialPaid ? 'Primera ' : ''}Donación:</strong>{' '}
            {formatCurrency(
              totalDonation / (inputs.partialPaid ? 2 : 1) +
                (Math.abs(parseInt(inputs.volunteerDonationAmount)) || 0)
            )}{' '}
            COP
          </div>
        )}
        <TarjetahabienteInfo
          event={firstEventOfQuery}
          inputs={inputs}
          errorInputs={errorInputs}
          handleInputs={handleInputs}
          selectHandle={selectHandle}
          totalDonation={totalDonation}
        />
      </>
    );
  };

  return (
    <StepFillDataContainer>
      <form onSubmit={(e) => nextStep(e)} className="Registration__form">
        {firstEventOfQuery?.additionalinformation?.confirmDataInfo && (
          <div>
            <ReactMarkdown className="line-break">
              {firstEventOfQuery?.additionalinformation?.confirmDataInfo}
            </ReactMarkdown>
          </div>
        )}
        <h2>{inputs.createdAt ? 'Confirma' : 'Llena'} los datos del asistente</h2>
        {defaulteventSlugname()?.toLowerCase()?.includes('camp') && (
          <p>Llena esto con la información del campista, de la persona que asistirá al Camp.</p>
        )}
        {Object.values(errorInputs)?.includes(true) && !shouldLockGuestIdentity(inputs) && (
          <h4>Por favor verifica los campos en rojo.</h4>
        )}
        {errorInputs?.Not_Complaint === true && (
          <Message negative>
            <Message.Header>
              Lo sentimos no cumples las condiciones para asistir a{' '}
              {firstEventOfQuery?.eventSlugname?.replace(/_/g, ' ')}.
            </Message.Header>
            <p>Si crees que es un error por favor escríbenos.</p>
          </Message>
        )}
        <Form
          saveTag={totalDonation ? 'Ir a donar' : 'Continuar'}
          Attendant={inputs}
          userprofile={true}
          handleInputs={handleInputs}
          handleDropDown={handleDropDown}
          errorInputs={errorInputs}
          sendInForm
          showAge
          showGender
          showCivil={reservationRequiresCivil(
            firstEventOfQuery?.eventSlugname || defaulteventSlugname?.()
          )}
          moreInfo={moreInfo}
          showBirthdate
          loadedData={loading}
          submit={(e) => nextStep(e)}
          setAttendant={setInputs}
          setErrorInputs={set_errorInputs}
          onGuestUpdated={onGuestUpdated}
        />
      </form>
    </StepFillDataContainer>
  );
};

export default ReservationStepFillData;
